import { Box, Stack, useTheme } from '@mui/material';
import { type RefObject, useContext, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import DownloadReportDialog from './components/DownloadReportDialog';
import MainContent from './components/MainContent';
import SearchBar from './components/SearchBar';
import SiteLookupContext from './context/SiteLookupContext';
import SiteLookupMapProvider from './context/SiteLookupMapProvider';
import SiteLookupProvider from './context/SiteLookupProvider';
import FilterChips from './filters/FilterChips';

const SiteDownloadReportDialog = () => {
  const { isDownloadingSitesReport } = useContext(SiteLookupContext);
  return <DownloadReportDialog open={isDownloadingSitesReport} />;
};

const SiteLookup = () => {
  const { palette, zIndex } = useTheme();

  // The header height varies (chips wrap): the list and the sticky map are laid out below the measured header.
  // border-box: the header's own padding is part of the space the map must clear.
  const headerRef = useRef<HTMLDivElement>(null);
  const { height: headerHeight } = useResizeObserver({ ref: headerRef as RefObject<HTMLDivElement>, box: 'border-box' });

  return (
    <SiteLookupProvider>
      <Stack height="100%" style={{ '--site-lookup-header-height': `${headerHeight ?? 76}px` } as React.CSSProperties}>
        <SiteLookupMapProvider>
          <Box
            ref={headerRef}
            display="flex"
            flexDirection="column"
            gap={1.5}
            paddingX={3}
            paddingY={2}
            position="sticky"
            sx={{
              top: 'calc(var(--top-bar-height) + 1px)',
              zIndex: zIndex.fab,
              minHeight: 'var(--search-bar-height)',
              backgroundColor: palette.common.white,
              boxShadow: '0 0 2px rgb(0 0 0 / 20%)',
            }}
          >
            <SearchBar />
            <FilterChips />
          </Box>
          <MainContent />
        </SiteLookupMapProvider>
      </Stack>

      <SiteDownloadReportDialog />
    </SiteLookupProvider>
  );
};

export default SiteLookup;
